import { Box, Container, Grid, Typography } from '@mui/material';
import Image from 'next/image';
import theme from 'src/style-system/theme';

import { CarouselType } from '@utils/types';

interface PosterSectionProps {
  PosterContent: CarouselType[];
}

const PosterSection = ({ PosterContent }: PosterSectionProps) => {
  return (
    <Box
      sx={{
        backgroundColor: 'turmeric.main',
        [theme.breakpoints.down('lg')]: {
          display: 'none',
        },
      }}
    >
      <Container maxWidth="xl" disableGutters>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            columnGap: '40px',
            padding: '80px 30px',
          }}
        >
          {PosterContent.map((content) => {
            return (
              <Box
                key={content.id}
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant="h3"
                  align="center"
                  color="cinnamon.main"
                  mb="30px"
                >
                  {content.title}
                </Typography>
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width:
                      content.alt === 'groupingBagBalanced' ? '300px' : '215px',
                    height: '215px',
                    borderRadius: content.alt === 'chopChef' ? '50%' : '0',
                    overflow: content.alt === 'chopChef' ? 'hidden' : 'auto',
                    [theme.breakpoints.down(1275)]: {
                      width:
                        content.alt === 'groupingBagBalanced'
                          ? '225px'
                          : '180px',
                    },
                  }}
                >
                  <Image
                    src={content.icon}
                    alt={content.alt}
                    objectFit="contain"
                    layout="fill"
                  />
                </Box>

                <Typography
                  variant="body2"
                  align="center"
                  color="garamMasala.main"
                  mt="35px"
                >
                  {content.subtitle}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};

export default PosterSection;
